import { XAxisVariable } from '../../../@types/projects/types';
import { useCorrelation } from '../../../providers/Correlation';
import { Tab, TabList, Tabs } from '../../tabs';

const X_AXIS_OPTIONS: { value: XAxisVariable; label: string; description: string }[] = [
  { value: 'fzi', label: 'FZI', description: 'Flow Zone Indicator' },
  { value: 'rqi', label: 'RQI', description: 'Reservoir Quality Index' },
];

const XAxisToggle = () => {
  const { selectedXAxis, toggleXAxisVariable } = useCorrelation();
  const onToggle = typeof toggleXAxisVariable === 'function'
    ? toggleXAxisVariable
    : () => undefined;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Tabs
        value={selectedXAxis}
        onChange={value => onToggle(value as XAxisVariable)}
        variant="pill"
        size="sm"
      >
        <TabList>
          {X_AXIS_OPTIONS.map(opt => (
            <Tab key={opt.value} value={opt.value}>
              {opt.label}
            </Tab>
          ))}
        </TabList>
      </Tabs>

      <span
        style={{
          fontSize: '11px',
          fontWeight: 600,
          color: '#8fa89e',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          userSelect: 'none',
        }}
      >
        X Axis
      </span>
    </div>
  );
};

export default XAxisToggle;
